/* Bramble & Bolt — global theme behaviour.
   Vanilla JS, no dependencies. Progressive enhancement: every feature here
   has a working no-JS fallback (links, native forms, <details>). */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* ---------- Drawers (mobile nav, basket) ---------- */
  var lastFocused = null;

  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    var first = drawer.querySelector(FOCUSABLE);
    if (first) first.focus();
    document.addEventListener('keydown', onDrawerKeydown);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onDrawerKeydown);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function onDrawerKeydown(event) {
    var drawer = document.querySelector('.bb-drawer[data-open="true"]');
    if (!drawer) return;
    if (event.key === 'Escape') {
      closeDrawer(drawer);
      return;
    }
    if (event.key !== 'Tab') return;
    var items = Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')));
      return;
    }
    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('.bb-drawer'));
    }
  });

  /* ---------- Desktop navigation dropdowns ---------- */
  function closeAllPanels(except) {
    document.querySelectorAll('.bb-nav__link[aria-expanded="true"]').forEach(function (btn) {
      if (btn === except) return;
      btn.setAttribute('aria-expanded', 'false');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.setAttribute('data-open', 'false');
    });
  }

  document.querySelectorAll('.bb-nav__link[aria-controls]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      var open = btn.getAttribute('aria-expanded') === 'true';
      closeAllPanels(btn);
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.setAttribute('data-open', open ? 'false' : 'true');
    });

    var item = btn.closest('.bb-nav__item');
    if (item) {
      item.addEventListener('mouseenter', function () {
        closeAllPanels(btn);
        btn.setAttribute('aria-expanded', 'true');
        panel.setAttribute('data-open', 'true');
      });
      item.addEventListener('mouseleave', function () {
        btn.setAttribute('aria-expanded', 'false');
        panel.setAttribute('data-open', 'false');
      });
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) {
          btn.setAttribute('aria-expanded', 'false');
          panel.setAttribute('data-open', 'false');
        }
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllPanels(null);
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.bb-nav')) closeAllPanels(null);
  });

  /* ---------- Mobile nav expanders ---------- */
  document.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = document.getElementById(btn.getAttribute('aria-controls'));
      if (!sub) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      sub.setAttribute('data-open', open ? 'false' : 'true');
    });
  });

  /* ---------- Accordions ---------- */
  document.querySelectorAll('.bb-accordion__trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
    });
  });

  /* ---------- Search panel + predictive search ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.getElementById('bb-search-panel');

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = searchPanel.getAttribute('data-open') === 'true';
      searchPanel.setAttribute('data-open', open ? 'false' : 'true');
      searchToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (!open) {
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && searchPanel.getAttribute('data-open') === 'true') {
        searchPanel.setAttribute('data-open', 'false');
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.focus();
      }
    });
  }

  var predictiveInput = document.querySelector('[data-predictive-input]');
  var predictiveResults = document.getElementById('bb-predictive-results');

  if (predictiveInput && predictiveResults) {
    var timer = null;
    var controller = null;

    predictiveInput.addEventListener('input', function () {
      var term = predictiveInput.value.trim();
      clearTimeout(timer);
      if (controller) controller.abort();

      if (term.length < 2) {
        predictiveResults.innerHTML = '';
        return;
      }

      timer = setTimeout(function () {
        controller = new AbortController();
        var url = '/search/suggest?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection,page&resources[limit]=6&section_id=bb-predictive-search';
        fetch(url, { signal: controller.signal })
          .then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('#bb-predictive-inner');
            predictiveResults.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(function () { /* silent: the full search page remains available */ });
      }, 220);
    });
  }

  /* ---------- Basket: quantity + remove, with a page fallback ---------- */
  function updateCart(line, quantity, root) {
    var busy = root || document.body;
    busy.setAttribute('aria-busy', 'true');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.href = '/cart'; });
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      updateCart(parseInt(remove.getAttribute('data-cart-remove'), 10), 0, remove.closest('.bb-cart-item'));
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) return;
    updateCart(parseInt(input.getAttribute('data-cart-quantity'), 10), qty, input.closest('.bb-cart-item'));
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('.bb-qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + step;
    if (next < min) next = min;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Carousel controls ---------- */
  document.querySelectorAll('[data-carousel-prev], [data-carousel-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var carousel = btn.closest('.bb-section') || document;
      var track = carousel.querySelector('.bb-carousel__track');
      if (!track) return;
      var amount = track.clientWidth * 0.8;
      track.scrollBy({ left: btn.hasAttribute('data-carousel-next') ? amount : -amount, behavior: 'smooth' });
    });
  });

  /* ---------- Recently viewed (this browser only) ---------- */
  var handleMeta = document.querySelector('meta[name="bb-product-handle"]');
  if (handleMeta) {
    try {
      var key = 'bb_recently_viewed';
      var list = JSON.parse(localStorage.getItem(key) || '[]');
      var handle = handleMeta.getAttribute('content');
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 8)));
    } catch (e) { /* storage unavailable — feature simply does not appear */ }
  }

  var recentHost = document.getElementById('bb-recently-viewed');
  if (recentHost) {
    try {
      var stored = JSON.parse(localStorage.getItem('bb_recently_viewed') || '[]');
      var current = recentHost.getAttribute('data-current') || '';
      var handles = stored.filter(function (h) { return h && h !== current; }).slice(0, 4);
      if (handles.length) {
        var query = handles.map(function (h) { return 'handle:' + h; }).join(' OR ');
        fetch('/search?type=product&q=' + encodeURIComponent(query) + '&section_id=bb-recently-viewed')
          .then(function (res) { return res.ok ? res.text() : Promise.reject(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('#bb-recently-inner');
            if (inner && inner.children.length) {
              recentHost.innerHTML = inner.innerHTML;
              recentHost.hidden = false;
            }
          })
          .catch(function () { /* section stays hidden */ });
      }
    } catch (e) { /* storage unavailable */ }
  }
})();